import React, { useCallback, useEffect } from 'react'
import { Navigate, useParams } from 'react-router-dom'
import { connect, useSelector } from 'react-redux'
import Navbar from '../../components/Navbar/Navbar'
import SportCourt from '../../components/Sports/SportCourt'
import { getSportCourt } from './sportPageData'
import routeConstant from '../../lib/constants/routeConstant'
import { getSeasonDetails } from '../../redux/slices/seasonSlice'
import CommonLoader from '../../components/shared/Loaders/CommonLoader/CommonLoader'
import { getUserOwnedTokensList } from '../../redux/slices/sportSlice'

const SportPage = ({ getSeason, getUserTokens }) => {
  const { sportsSeasonId } = useParams();

  const { fetchingSport, error, currentSeason, fetchingSeasons, fetchedSeasons } = useSelector(state => state.seasons);
  const { totalCount } = useSelector(state => state.cart);

  const callApi = useCallback(async() => {
    if(!sportsSeasonId) return;

    await getSeason({ seasonId: sportsSeasonId }); // get season details
    await getUserTokens({ seasonId: sportsSeasonId }); // get User Tokens
  }, [sportsSeasonId, getSeason, getUserTokens]);

  useEffect(() => {
    callApi();
  }, [callApi]);

  if(fetchingSport || fetchingSeasons || !fetchedSeasons) {
    return <CommonLoader />
  }

  const checkSportGround = getSportCourt(currentSeason?.seasonCode)

  // check if sport season id is valid or not
  if(!sportsSeasonId || !currentSeason ||!checkSportGround || error) {
    return <Navigate to={routeConstant.PAGE_NOT_FOUND} />
  }

  return (
    <main>
      <Navbar
        // courtTitle={currentSeason?.seasonName || ""}
        disableCart={!totalCount}
        showSeasonDropdown={false}
      />

      {/* Court */}
      <SportCourt
        CourtGround={checkSportGround}
        hideZoneName={true}
      />
    </main>
  )
}

const mapDispatchToProps = (dispatch) => ({
  getSeason: (data) => dispatch(getSeasonDetails(data)),
  getUserTokens: (data) => dispatch(getUserOwnedTokensList(data))
});

export default connect(null, mapDispatchToProps)(React.memo(SportPage));